import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getOrders as getOrdersApi,
  addNewOrder as addNewOrderApi,
  updateOrder as updateOrderApi,
  cancelOrder as cancelOrderApi,
  getInvoice as getInvoiceApi,
} from "../../apiCalls/caller";

export const getOrders = createAsyncThunk("orders/getOrders", async (data) => {
  try {
    const response = getOrdersApi(data);
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewOrder = createAsyncThunk(
  "orders/addNewOrder",
  async (order, { rejectWithValue }) => {
    try {
      toast.loading("Sending Order...", {
        position: "top-center",
      });
      const response = addNewOrderApi(order);
      const data = await response;
      toast.dismiss();
      
      if (data.success === false) {
        toast.error(
          <div>
            {data.message || "Order Added Failed"}
            {" "}
            <a href="/billing" style={{ color: "#fff", textDecoration: "underline" }}>
              Go to Billing
            </a>
          </div>,
          {
            position: "top-center",
            autoClose: 5000,
          }
        );
        return rejectWithValue(data);
      }
      
      toast.success("Order Placed Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.dismiss();
      toast.error("Order Added Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return rejectWithValue(error);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
  async (order, { rejectWithValue }) => {
    try {
      const response = updateOrderApi(order);
      const data = await response;
      toast.dismiss();
      
      if (data.success === false) {
        toast.error(
          <div>
            {data.message || "Order Updated Failed"}
            {" "}
            <a href="/billing" style={{ color: "#fff", textDecoration: "underline" }}>
              Go to Billing
            </a>
          </div>,
          {
            position: "top-center",
            autoClose: 5000,
          }
        );
        return rejectWithValue(data);
      }
      
      toast.success("Order Updated Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.dismiss();
      toast.error("Order Updated Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return rejectWithValue(error);
    }
  }
);

export const cancelOrder = createAsyncThunk(
  "orders/cancelOrder",
  async (order, { rejectWithValue }) => {
    try {
      toast.loading("Cancelling Order...", {
        position: "top-center",
      });
      const response = cancelOrderApi(order);
      const data = await response;
      toast.dismiss();
      
      if (data.success === false) {
        toast.error(
          <div>
            {data.message || "Order Cancel Failed"}
            {" "}
            <a href="/billing" style={{ color: "#fff", textDecoration: "underline" }}>
              Go to Billing
            </a>
          </div>,
          {
            position: "top-center",
            autoClose: 5000,
          }
        );
        return rejectWithValue(data);
      }
      
      toast.success("Order Cancelled Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.dismiss();
      toast.error("Order Cancel Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return rejectWithValue(error);
    }
  }
);

export const getInvoice = createAsyncThunk(
  "orders/getInvoice",
  async (data) => {
    try {
      const response = getInvoiceApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
